"use client";

import type { InsightsGenuiAbstain } from "./parse-genui";

/**
 * Structured GenUI abstain final — terminal "cannot answer" card.
 * Callers: InsightsAnswer when tryParseGenuiSpecStreaming returns type:"abstain".
 */
export function InsightsGenuiAbstainView({
  spec,
  live,
}: {
  spec: InsightsGenuiAbstain;
  live?: boolean;
}) {
  return (
    <div className="space-y-3 p-4" data-genui="abstain" data-live={live ? "true" : undefined}>
      <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 px-4 py-3">
        <p className="text-[11px] font-medium uppercase tracking-wide text-amber-700 dark:text-amber-400">
          Cannot answer yet
        </p>
        <p className="mt-1 text-sm leading-6 text-foreground">{spec.summary}</p>
      </div>
      {spec.reasons?.length ? (
        <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-foreground/80">
          {spec.reasons.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      ) : null}
      {spec.nextSteps?.length ? (
        <div>
          <p className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
            Next steps
          </p>
          <ol className="mt-1 list-decimal space-y-1 pl-5 text-sm leading-6 text-foreground/80">
            {spec.nextSteps.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ol>
        </div>
      ) : null}
    </div>
  );
}
